export type ContactValues = {
  name: string;
  phone: string;
  email: string;
  projectType: string;
  locality: string;
  message: string;
  consent: boolean;
};

export type ContactErrors = Partial<Record<keyof ContactValues, string>>;

export const EMPTY_CONTACT: ContactValues = {
  name: "",
  phone: "",
  email: "",
  projectType: "",
  locality: "",
  message: "",
  consent: false,
};

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const PHONE_RE = /^[+\d][\d\s()]{8,}$/;

export function validateContact(values: ContactValues): ContactErrors {
  const errors: ContactErrors = {};

  if (!values.name.trim()) {
    errors.name = "Vyplňte jméno a příjmení.";
  }

  const phone = values.phone.trim();
  if (!phone) {
    errors.phone = "Vyplňte telefon.";
  } else if (!PHONE_RE.test(phone)) {
    errors.phone = "Zadejte telefon v platném formátu (např. +420 123 456 789).";
  }

  const email = values.email.trim();
  if (email && !EMAIL_RE.test(email)) {
    errors.email = "Zadejte e-mail v platném formátu.";
  }

  if (!values.consent) {
    errors.consent = "Bez souhlasu se zpracováním údajů nelze poptávku odeslat.";
  }

  return errors;
}
